import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './profA1InitialState';
import {
  _setParticipantName,
  _setcdcNumber,
  _setDob,
  _setCountyofLastLegalResidence,
  _setParoleRegion,
  _setSat,
  _setSatShortName,
  _setCsarScore,
  _setAsiScore,
  _setSecondaryScore,
  _setPermanentAddress,
  _setPermanentCity,
  _setPermanentZipCode,
  _setTelephoneNumber,
  _setMaritalStatusId,
  _setEthnicGroupId,
  _setPrimaryLanguage,
  _setHighestEducationId,
  _setUsualOccupation,
  _setYears,
  _setNumberofChildren,
  _setAges,
  _setIsCSBOrCPSInvolved,
  _setChildrenLiveWith,
  _setEmergencyContact1Name,
  _setEmergencyContact1Address,
  _setEmergencyContact1City,
  _setEmergencyContact1Phone,
  _setEmergencyContact1Relationship,
  _setEmergencyContact2Name,
  _setEmergencyContact2Address,
  _setEmergencyContact2City,
  _setEmergencyContact2Phone,
  _setEmergencyContact2Relationship,
  _setClassifiedCCCMS,
  _setClassifiedCCCMSYear,
  _setClassifiedCCCMSClearedYear,
  _setMedComments,
  _setMedicineName1,
  _setMedicineName2,
  _setMedicineName3,
  _setMedicineCondition1,
  _setMedicineCondition2,
  _setMedicineCondition3,
  _setADA,
  _setVeteran,
  _setIsProfA1DataLoaded,
} from './profA1ModelActions'
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfA1Form = createAsyncThunk(
  'stop/getProfA1Form',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profA1Slice = createSlice({
  name: 'stop/profA1',
  initialState,
  reducers: {
    setIsProfA1DataLoaded: _setIsProfA1DataLoaded,
    setParticipantName: _setParticipantName,
    setCDCNumber: _setcdcNumber,
    setDOB: _setDob,
    setCountyofLastLegalResidence: _setCountyofLastLegalResidence,
    setParoleRegion: _setParoleRegion,
    setSat: _setSat,
    setSatShortName: _setSatShortName,
    setCsarScore: _setCsarScore,
    setAsiScore: _setAsiScore,
    setSecondaryScore: _setSecondaryScore,
    setPermanentAddress: _setPermanentAddress,
    setPermanentCity: _setPermanentCity,
    setPermanentZipCode: _setPermanentZipCode,
    setTelephoneNumber: _setTelephoneNumber,
    setMaritalStatusId: _setMaritalStatusId,
    setEthnicGroupId: _setEthnicGroupId,
    setPrimaryLanguage: _setPrimaryLanguage,
    setHighestEducationId: _setHighestEducationId,
    setUsualOccupation: _setUsualOccupation,
    setYears: _setYears,
    setNumberofChildren: _setNumberofChildren,
    setAges: _setAges,
    setIsCSBOrCPSInvolved: _setIsCSBOrCPSInvolved,
    setChildrenLiveWith: _setChildrenLiveWith,
    setEmergencyContact1Name: _setEmergencyContact1Name,
    setEmergencyContact1Address: _setEmergencyContact1Address,
    setEmergencyContact1City: _setEmergencyContact1City,
    setEmergencyContact1Phone: _setEmergencyContact1Phone,
    setEmergencyContact1Relationship: _setEmergencyContact1Relationship,
    setEmergencyContact2Name: _setEmergencyContact2Name,
    setEmergencyContact2Address: _setEmergencyContact2Address,
    setEmergencyContact2City: _setEmergencyContact2City,
    setEmergencyContact2Phone: _setEmergencyContact2Phone,
    setEmergencyContact2Relationship: _setEmergencyContact2Relationship,
    setClassifiedCCCMS: _setClassifiedCCCMS,
    setClassifiedCCCMSYear: _setClassifiedCCCMSYear,
    setClassifiedCCCMSClearedYear: _setClassifiedCCCMSClearedYear,
    setMedComments: _setMedComments,
    setMedicineName1: _setMedicineName1,
    setMedicineName2: _setMedicineName2,
    setMedicineName3: _setMedicineName3,
    setMedicineCondition1: _setMedicineCondition1,
    setMedicineCondition2: _setMedicineCondition2,
    setMedicineCondition3: _setMedicineCondition3,
    setADA: _setADA,
    setVeteran: _setVeteran,
    //resetReferral: () => null,
  },
  extraReducers: {
    [getProfA1Form.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setIsProfA1DataLoaded,
  setParticipantName,
  setCDCNumber,
  setDOB,
  //resetReferral,
  setCountyofLastLegalResidence,
  setParoleRegion,
  setSat,
  setSatShortName,
  setCsarScore,
  setAsiScore,
  setSecondaryScore,
  setPermanentAddress,
  setPermanentCity,
  setPermanentZipCode,
  setTelephoneNumber,
  setMaritalStatusId,
  setEthnicGroupId,
  setPrimaryLanguage,
  setHighestEducationId,
  setUsualOccupation,
  setYears,
  setNumberofChildren,
  setAges,
  setIsCSBOrCPSInvolved,
  setChildrenLiveWith,
  setEmergencyContact1Name,
  setEmergencyContact1Address,
  setEmergencyContact1City,
  setEmergencyContact1Phone,
  setEmergencyContact1Relationship,
  setEmergencyContact2Name,
  setEmergencyContact2Address,
  setEmergencyContact2City,
  setEmergencyContact2Phone,
  setEmergencyContact2Relationship,
  setClassifiedCCCMS,
  setClassifiedCCCMSYear,
  setClassifiedCCCMSClearedYear,
  setMedComments,
  setMedicineName1,
  setMedicineName2,
  setMedicineName3,
  setMedicineCondition1,
  setMedicineCondition2,
  setMedicineCondition3,
  setADA,
  setVeteran,
} = profA1Slice.actions;

export default profA1Slice.reducer;
